/**
@ngdoc controller
@name JobPostingCtrl

@description
This controller is used in Item or Distribution -  JobPosting.

*/
(function() {
    'use strict';
    var JobPostingCtrl = function($scope, $timeout) {

        $scope.disablePostButton = false;
        $scope.DEBUG = true;
        if($scope.DEBUG){
            console.log('JobPostingCtrl loaded');
            console.log('$scope',$scope);
            console.log('$scope.ngModel',$scope.ngModel);
        }
        var DELAY_CKEDITOR = false;
        //lookup val ids and max limits
        $scope.CONFIG = {
            REED_GLOBAL:    {ID: 5292, MAX: 5},
            REED_CO_UK:     {ID: 5293, MAX: 5},
            BROADBEAN:      {ID: 5294, MAX: 1},
            BOTH_REEDS:     {ID: 5295}
        };

        $scope.EXPIRY_SELECTION = {
            ONE_WEEK: 5277,
            TWO_WEEK: 5278,
            ONE_MONTH: 5279,
            NO_CHANGE: 5337
        }

        $scope.ngModel.jobPosting.reportError = false;

        $scope.init = function(DEBUG, existingCountReedGlobal, existingCountReedCoUK){
            console.log('JobPostingCtrl.init()',DEBUG, existingCountReedGlobal, existingCountReedCoUK);
            $scope.DEBUG = DEBUG;
            //Initalise the boards
            $scope.boards = {
                reedGlobal: $scope.fnInitCountBoard(
                    existingCountReedGlobal, $scope.CONFIG.REED_GLOBAL, $scope.CONFIG.BOTH_REEDS
                ),
                reedCoUk:  $scope.fnInitCountBoard(
                    existingCountReedCoUK,   $scope.CONFIG.REED_CO_UK,  $scope.CONFIG.BOTH_REEDS
                ),
                broadbean: $scope.fnInitCountBoard(
                    0,                       $scope.CONFIG.BROADBEAN,   null
                )
            };
        };

        $scope.fnBoardDetailModelInit = function (mode) {

            angular.forEach($scope.jobPostingModel.boardDetailModel, function(jobPostingRow) {
                if(mode != "CREATE") {
                    jobPostingRow.isExising = true;
                }
            });
        };

        $scope.resetValues = function (values) {
            values.jobPosting.currency = ''
            values.jobPosting.payType  = ''
            values.boardDetailList.forEach(function(boardDetail) {
                boardDetail.town         = [];
                boardDetail.postCode     = [];
                boardDetail.locationName = []
            })
        }

        if(DELAY_CKEDITOR){
            $scope.ngModel.jobPosting = {};
            $scope.loading      = true;
            $scope.loadingError = false;
            // added watch event to delay the ckEditor load, in order to avoid
            //destory() on ckEditor before it is fully initialized
            $scope.ngModel.jobPosting.delayedEditorLoad = true;
            $scope.$watch(
                function(){
                     return $scope.ngModel.jobPosting.distributionId;
                },
                function(newVal, oldVal){
                    if(newVal!=oldVal){

                        $scope.ngModel.jobPosting.delayedEditorLoad = false;
                        $timeout(function(){
                            $scope.ngModel.jobPosting.delayedEditorLoad = true;
                        });
                    }
                }
            );
        }

        // duplicated from app.js as modal window doesn't have the access to the main scope
        $scope.ckLoad = {
            ckeditor: {
                name:'ngCkeditor', files:[
                WEBAPP_PATH + '/js/vendor/angular/ng-ckeditor/ng-ckeditor.js',
                WEBAPP_PATH + '/js/vendor/CKEditor/ckeditor.js'
            ]}
        };

        //Sets up a standardized board object
        //initial count, 1st config reference , 2nd config reference
        $scope.fnInitCountBoard = function( initialCount, BOARD_ONE_CONFIG_REF, BOARD_TWO_CONFIG_REF ){
            var countBoard = {
                initialCount: initialCount,
                counter:    0,
                BOARD_ONE:  BOARD_ONE_CONFIG_REF,
                BOARD_TWO:  BOARD_TWO_CONFIG_REF
            };
            if( $scope.DEBUG ){ console.log( 'fnInitCountBoard() returns', countBoard); }
            return countBoard;
        };

        //Incraments board counts and flags any exceeding maximum
        $scope.fnIncrementCountBoard = function(jobPostingRow, board, sourceOfInvocation) {
            if($scope.DEBUG) {
                console.log("$scope.jobPostingModel => ", $scope.jobPostingModel);
                console.log("$scope.jobPostingModel.mode => ", $scope.jobPostingModel.mode);
                console.log("PRE board => ", board);
                console.log("sourceOfInvocation => ", sourceOfInvocation);
            }
            //lookup val id of board selected
            var boardId = jobPostingRow.board.id;
            //If the board matches this id or the other id
            if( boardId == board.BOARD_ONE.ID || ( board.BOARD_TWO != null && boardId == board.BOARD_TWO.ID ) ){
                //Incrament the counter
                if(sourceOfInvocation != 'init' && jobPostingRow.isExising != true) {
                    board.counter++;
                }
                //If it's not been already flagged as invalid
                if( jobPostingRow.countInvalid == false ){
                    //Set count as invalid if the counter exceeds the maximum configured
                    jobPostingRow.countInvalid = ( board.counter > board.BOARD_ONE.MAX );
                }
            }
            if($scope.DEBUG){
                console.log( 'fnCountBoards() fnIncrementCountBoard()', jobPostingRow, board );
            }
            console.log("jobPostingRow.countInvalid => ", jobPostingRow.countInvalid);
        };

        //Resets counter to initial count size
        $scope.fnResetCountBoard = function( boards ){
            angular.forEach( boards, function(board){
                board.counter = board.initialCount;
            });
            if($scope.DEBUG){
                console.log( 'fnCountBoards() fnResetCountBoard()' );
            }
        }
        /*
        $scope.fnIsFormValid = function(){
            var countsAreValid = $scope.fnCountBoards();
            var isValid = ($scope.jobPostingForm.$valid && countsAreValid);
            if($scope.DEBUG){console.log( 'fnIsFormValid() ', $scope.jobPostingForm.$valid, countsAreValid, isValid );}
            $scope.jobPostingForm.$valid = isValid;
            return isValid;
        }
        */

        //Counts the number of job boards for pre-existing job postings
        //@return counters are all valid
        $scope.fnCountBoards = function(sourceOfInvocation){
            if($scope.DEBUG){
                console.log( 'fnCountBoards() $scope', $scope );
                //here this is $scope.jobPostingForm
                //outside this is $scope.ngModel.jobPosting
                console.log( 'fnCountBoards() $scope.jobPostingForm', $scope.jobPostingForm );
                console.log( 'fnCountBoards() $scope.boards', $scope.boards );
            }
            $scope.fnResetCountBoard( $scope.boards );
            $scope.ngModel.jobPosting.boardCountValid = 'valid';
                if($scope.jobPostingModel.isDraft) {
                    //loop through each row
                    angular.forEach($scope.jobPostingModel.boardDetailModel, function(jobPostingRow) {
                        if(jobPostingRow.board) {
                            if($scope.DEBUG){
                                console.log('fnCountBoards() jobPostingModel.boardDetailModel.forEach() ', $scope.boards);
                            }
                            //Set row's count as currently valid
                            jobPostingRow.countInvalid = false;
                            //Incrament reedGlobal
                            $scope.fnIncrementCountBoard( jobPostingRow, $scope.boards.reedGlobal, sourceOfInvocation);
                            //Incrament reedCoUk
                            $scope.fnIncrementCountBoard( jobPostingRow, $scope.boards.reedCoUk, sourceOfInvocation);
                            //Incrament broadbean
                            $scope.fnIncrementCountBoard( jobPostingRow, $scope.boards.broadbean, sourceOfInvocation);
                            // set the overallCountersInvalid to true when any one of the jobBoards have
                            // exceeded the limit
                            console.log("jobPostingRow.countInvalid => ", jobPostingRow.countInvalid);
                            if(jobPostingRow.countInvalid){
                                $scope.ngModel.jobPosting.boardCountValid = '';
                                return false;
                            }
                        }
                    });
                }
            if($scope.DEBUG){
                console.log( 'fnCountBoards()', $scope.ngModel.jobPosting.boardCountValid );
            }
            return true;
        }

        $scope.$watchCollection('jobPostingModel.boardDetailModel.length', function(newBoardDetailLength,oldBoardDetailLength) {
            if(newBoardDetailLength == oldBoardDetailLength +1 ){
                var newBoardDetailModel = $scope.jobPostingModel.boardDetailModel;
                newBoardDetailModel[newBoardDetailModel.length - 1].postCode = [$scope.jobPostingModel.defaultPostcode];
            }
        });

        $scope.fnValidateSave = function($event) {
            $timeout(function(){
                $scope.disablePostButton = true;
            });
            var isValid = $scope.fnCountBoards("save");
            console.log("fnValidateSave Validate => ", isValid);
            if($scope.ngModel.jobPosting.boardCountValid == "") {
                $event.preventDefault();
                $timeout(function(){
                    $scope.disablePostButton = false;
                });
                return false;
            }
            return true;
        };

        $scope.fnValidatePost = function($event){
            $timeout(function(){
                $scope.disablePostButton = true;
            });
/*
            $timeout(function(){
                $scope.disablePostButton = false;
            }, 10000);
*/

            $scope.ngModel.jobPosting.reportError = false;
            //if there are no existing reed job postings, check if job reed is selected in drop down to post
            if($scope.ngModel.jobPosting.postToBroadbeanAfterReed == 'true'
                && $scope.ngModel.jobPosting.hasReedPostings != 'true'
                && ($scope.boards.broadbean.counter != 0)) {
                    if($scope.boards.reedCoUk.counter == 0 || $scope.boards.reedGlobal.counter == 0){
                        $scope.ngModel.jobPosting.reportError = true;
                        $('.modal').animate({ scrollTop: 0 }, 'slow');
                    }
            }
            if($scope.ngModel.jobPosting.postToBroadbeanAfterReed != 'true' || !($scope.ngModel.jobPosting.reportError)){
                $scope.fnCountBoards("save");
            }
            //return !reportError;
            if($scope.ngModel.jobPosting.reportError || ($scope.ngModel.jobPosting.boardCountValid == '')){
                $event.preventDefault();
                $timeout(function(){
                    $scope.disablePostButton = false;
                });
                return false;
            }
            return true;
        };

        $scope.currentExpiryDate = null;

        $scope.setExpiryDate = function() {

            if($scope.currentExpiryDate==null){
                $scope.currentExpiryDate = new Date($scope.ngModel.jobPosting.expiryDate);
            }
            var expiryDate = new Date();
            var expirySelectionId = parseInt($scope.ngModel.jobPosting.expirySelectionId);
            switch(expirySelectionId) {
                case $scope.EXPIRY_SELECTION.ONE_WEEK:
                    expiryDate.setDate(expiryDate.getDate() + 1*7);
                break;
                case $scope.EXPIRY_SELECTION.TWO_WEEK:
                    expiryDate.setDate(expiryDate.getDate() + 2*7);
                break;
                case $scope.EXPIRY_SELECTION.ONE_MONTH:
                    expiryDate.setMonth(expiryDate.getMonth() + 1);
                break;
                case $scope.EXPIRY_SELECTION.NO_CHANGE:
                    expiryDate.setDate($scope.currentExpiryDate.getDate());
                break;
                default:
                    expiryDate = null;
            }

            $scope.ngModel.jobPosting.expiryDate = expiryDate;
        };

        //$scope.fnCountBoards();
      $scope.ckeditorOptions = {
        // Remove the Format plugin to fully hide Format dropdown and styles
        removePlugins: 'format',

        // Define toolbar WITHOUT 'Format'
        toolbar: [
          { name: 'basicstyles', items: [ 'Bold', 'Italic','Strike','Underline' ] },
          { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', 'Blockquote'] },
          {name: 'editing', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']},
          { name: 'insert', items: [ 'Image', 'Table' ] },
          { name: 'editing', items: [ 'Scayt' ] },
          { name: 'tools', items: [ 'Maximize' ] },

        ]
      };
    }
    JobPostingCtrl.$inject = ['$scope', '$timeout'];
    angular.module('app').controller('JobPostingCtrl', JobPostingCtrl);
}());
